import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { consumeAuthFromUrl } from "../Utils";

const ProtectedRoute = () => {
  const [userAllow, setUserAllow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    consumeAuthFromUrl();
    const authToken = localStorage.getItem("isAuthenticated");


    if (authToken) {
      setUserAllow(true);
    } else {
      navigate("/"); // Redirect to login page if not authenticated
    }
        //  setUserAllow(true);

  }, [navigate]);

  return userAllow ? <Outlet /> : null; // Show the page only if authenticated
};

export default ProtectedRoute;
